module.exports = __webpack_public_path__ + "img/solu1.3ff7f4fb.png";